import React from 'react'
import { Link } from 'react-router-dom'
import EntryTypeBadge from './EntryTypeBadge'

// Compact "Related in Catalog" section rendered under a streamed Q&A answer.
// The shape comes from Ai::QueryEngine's :related_catalog_entries event:
//   [{ id, title, entry_type, summary }, ...]
//
// Intentionally subtle — supplements the answer without crowding it.
export default function RelatedCatalogEntries({ entries }) {
  if (!entries || entries.length === 0) return null

  return (
    <div className="pt-3 mt-3 border-t border-slate-100">
      <div className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-2">
        Related in Catalog
      </div>
      <div className="space-y-2">
        {entries.slice(0, 3).map((entry) => (
          <Link
            key={entry.id}
            to={`/catalog/${entry.id}`}
            className="flex items-start gap-3 rounded-lg border border-slate-200 bg-white px-3 py-2 transition hover:border-accent-300 hover:bg-accent-50/40"
          >
            <div className="min-w-0 flex-1">
              <div className="text-sm font-medium text-slate-900 truncate">
                {entry.title}
              </div>
              {entry.summary && (
                <p className="mt-0.5 text-xs text-slate-500 line-clamp-1">
                  {entry.summary}
                </p>
              )}
            </div>
            <EntryTypeBadge entryType={entry.entry_type} className="shrink-0" />
          </Link>
        ))}
      </div>
    </div>
  )
}
